import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHits } from 'react-instantsearch';

import SearchEmptyState from '../../SearchEmptyState';
import type { SearchForumCategoriesHit } from '../types';
import Hit from './Hit';

import './style.scss';

export interface SearchForumCategoriesResultsProps {
  className?: string;
}

const SearchForumCategoriesResults: React.FC<SearchForumCategoriesResultsProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { hits } = useHits<SearchForumCategoriesHit>();

  const classNames = c('SearchForumCategories__Results', className);

  return (
    <>
      <h3 className="SearchForumCategories__title">{t('pages.forum.categories.labels.forum_categories')}</h3>
      {hits.length === 0 ? (
        <SearchEmptyState
          title={t('pages.forum.categories.empty_state')}
        />
      ) : (
        <ul className={classNames}>
          {hits.map((hit) => (
            <li><Hit key={hit.tid[0]} hit={hit} /></li>
          ))}
        </ul>
      )}
    </>
  );
};

export default SearchForumCategoriesResults;
